import router from '../router';

export default {
  // 跟进当前路由获取pageFrom拼接传入newPageFrom,返回跳转下一个页面需要的page_from
  getPageFrom(pageName) {
    const route = router.currentRoute;
    let curPageFrom = route.query.page_from || '';
    // 处理异常情况，有两个page_from
    if (Array.isArray(curPageFrom)) curPageFrom = curPageFrom[0];
    // 无需拼接，直接返回
    if (!pageName) return { page_from: curPageFrom };
    
    // 解决nav-list-country固定顶部，导致可以多次添加重复一个路径问题
    if (curPageFrom) {
      curPageFrom = curPageFrom.split('_').filter(page => page !== pageName).join('_');
    }
    // 需要拼接
    const pageFrom = curPageFrom ? `${curPageFrom}_${pageName}` : pageName;
    return { page_from: pageFrom };
  },
  // 处理url不明的情况
  getURL(url, pageName) {
    try {
      const urlObj = new URL(url);
      const pageFrom = this.getPageFrom(pageName);
      Object.keys(pageFrom).forEach((key) => {
        urlObj.searchParams.set(key, pageFrom[key]);
      });
      return urlObj.toString();
    } catch (error) {
      console.log(error);
      return url;
    }
  },
};




// WEBPACK FOOTER //
// ./src/services/sensor-service.js